import { render, staticRenderFns } from "./MatchingTest.vue?vue&type=template&id=c3d2af16&"
import script from "./MatchingTest.vue?vue&type=script&lang=js&"
export * from "./MatchingTest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports